import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'rotate-clockwise', 'RotateClockwise', [["path",{"d":"M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5"}]]);